var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddaudiohover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 23.06C11.14 23.06 10.7133 22.92 10.42 22.64C10.14 22.36 10 22 10 21.56C10 21.1467 10.1133 20.7733 10.34 20.44C10.5667 20.0933 10.86 19.82 11.22 19.62C11.58 19.4067 11.96 19.3 12.36 19.3C12.72 19.3 13.0333 19.3733 13.3 19.52V11L21.18 9V18.82C21.18 19.54 21.0267 20.16 20.72 20.68C20.4267 21.2 20.04 21.5933 19.56 21.86C19.08 22.1267 18.5733 22.26 18.04 22.26C17.48 22.26 17.0533 22.12 16.76 21.84C16.4667 21.56 16.32 21.2 16.32 20.76C16.32 20.3467 16.4333 19.9733 16.66 19.64C16.9 19.2933 17.2 19.02 17.56 18.82C17.92 18.6067 18.3 18.5 18.7 18.5C19.0467 18.5 19.3533 18.5733 19.62 18.72V11.3L14.84 12.62V19.62C14.84 20.34 14.6867 20.96 14.38 21.48C14.0867 22 13.7 22.3933 13.22 22.66C12.74 22.9267 12.2333 23.06 11.7 23.06Z",
    fill: "#FEFEFE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#FEFEFE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddaudiohover);
export default __webpack_public_path__ + "static/media/addaudiohover.9b16c656.svg";
export { ForwardRef as ReactComponent };var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddaudiohover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 23.06C11.14 23.06 10.7133 22.92 10.42 22.64C10.14 22.36 10 22 10 21.56C10 21.1467 10.1133 20.7733 10.34 20.44C10.5667 20.0933 10.86 19.82 11.22 19.62C11.58 19.4067 11.96 19.3 12.36 19.3C12.72 19.3 13.0333 19.3733 13.3 19.52V11L21.18 9V18.82C21.18 19.54 21.0267 20.16 20.72 20.68C20.4267 21.2 20.04 21.5933 19.56 21.86C19.08 22.1267 18.5733 22.26 18.04 22.26C17.48 22.26 17.0533 22.12 16.76 21.84C16.4667 21.56 16.32 21.2 16.32 20.76C16.32 20.3467 16.4333 19.9733 16.66 19.64C16.9 19.2933 17.2 19.02 17.56 18.82C17.92 18.6067 18.3 18.5 18.7 18.5C19.0467 18.5 19.3533 18.5733 19.62 18.72V11.3L14.84 12.62V19.62C14.84 20.34 14.6867 20.96 14.38 21.48C14.0867 22 13.7 22.3933 13.22 22.66C12.74 22.9267 12.2333 23.06 11.7 23.06Z",
    fill: "#FEFEFE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    stroke: "#FEFEFE",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddaudiohover);
export default __webpack_public_path__ + "static/media/addaudiohover.9b16c656.svg";
export { ForwardRef as ReactComponent };